import styled from "styled-components";

export const Wrap = styled.div`
  width: 360px;
  flex-shrink: 0;
  position: sticky;
  top: 134px;
  max-height: calc(100vh - 162px);
  display: flex;
  flex-direction: column;
  background: ${(p) => p.theme.tokens.colors.surface};
  border-radius: ${(p) => p.theme.tokens.radii.xl}px;
  box-shadow: ${(p) => p.theme.tokens.shadows.card};
  overflow: hidden;
  font-family: ${(p) => p.theme.tokens.font.family};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 18px;
  border-bottom: 1px solid ${(p) => p.theme.tokens.colors.line};
`;

export const HeaderIconBadge = styled.span`
  width: 36px;
  height: 36px;
  border-radius: 11px;
  background: ${(p) => p.theme.tokens.colors.softTeal};
  color: ${(p) => p.theme.tokens.colors.teal};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const HeaderText = styled.div`
  flex: 1;
`;

export const Title = styled.div`
  font-weight: 900;
  font-size: 16.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const Count = styled.div`
  color: ${(p) => p.theme.tokens.colors.muted};
  font-size: 12px;
`;

export const ClearButton = styled.button`
  border: none;
  background: none;
  color: #c0392b;
  font-weight: 800;
  font-size: 12.5px;
  cursor: pointer;
`;

export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 44px 28px;
  color: ${(p) => p.theme.tokens.colors.muted};
  text-align: center;
`;

export const EmptyIconBadge = styled.span`
  width: 72px;
  height: 72px;
  border-radius: ${(p) => p.theme.tokens.radii.xl}px;
  background: ${(p) => p.theme.tokens.colors.softTeal};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
`;

export const EmptyTitle = styled.div`
  font-weight: 800;
  color: ${(p) => p.theme.tokens.colors.ink};
  font-size: 15px;
`;

export const EmptyHint = styled.div`
  font-size: 13px;
  margin-top: 4px;
  line-height: 1.4;
`;

export const List = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 6px 18px;
`;

export const Item = styled.div`
  display: flex;
  gap: 11px;
  padding: 12px 0;

  & + & {
    border-top: 1px solid ${(p) => p.theme.tokens.colors.line};
  }
`;

export const ThumbWrap = styled.div`
  width: 50px;
  height: 50px;
  flex-shrink: 0;
`;

export const ItemInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ItemName = styled.div`
  font-weight: 800;
  font-size: 13.5px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const ItemExtras = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 2px;
`;

export const ItemObs = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 2px;
  font-style: italic;
`;

export const FlavourNote = styled.div`
  font-size: 11.5px;
  color: ${(p) => p.theme.tokens.colors.muted};
  margin-top: 6px;
`;

export const ItemRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
`;

export const ItemTotal = styled.div`
  font-weight: 800;
  font-size: 13px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const RemoveButton = styled.button`
  border: none;
  background: none;
  color: ${(p) => p.theme.tokens.colors.muted};
  cursor: pointer;
  padding: 2px;
`;

export const Footer = styled.div`
  padding: 14px 18px 18px;
  border-top: 1px solid ${(p) => p.theme.tokens.colors.line};
`;

export const FooterDivider = styled.div`
  height: 1px;
  background: ${(p) => p.theme.tokens.colors.line};
  margin: 9px 0;
`;

export const TotalRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 12px;
`;

export const TotalLabel = styled.span`
  font-weight: 900;
  font-size: 15px;
  color: ${(p) => p.theme.tokens.colors.ink};
`;

export const TotalValue = styled.span`
  font-weight: 900;
  font-size: 20px;
  color: ${(p) => p.theme.tokens.colors.teal};
`;
